import { useMapType } from 'hooks/maps.hooks';

const MapLoad = ({ children }) => {
  const { isLoading } = useMapType();

  return isLoading ? null : children;
};
export default MapLoad;
